import AddDarajat from "./combo/addDarajat";
import EditDarajat from "./combo/editDarajat";

import {useCallback, useEffect, useState} from "react";
import React from "react";
import axios from "axios";
import Select from "react-select";
import "./style.css";
import {url} from "./BaseUrl"; // Import your CSS file
const tele = window.Telegram.WebApp;
tele.expand();
function DarajatAdmin(){
    const [isLoading, setIsLoading] = useState(false); // State for loading indicator
    const [addDarajat, setaddDarajat] = useState(false);
    const [editDarajat, seteditDarajat] = useState(false);

    const [groups, setGroups] = useState([]);
    const user_id = tele.initDataUnsafe?.user?.id;

    async function getDarajat() {
        setIsLoading(true);
        try {
            await axios.get(url+'/get_darajats',
                {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                .then((res) => {
                    setGroups(res.data);
                    setFilteredGroups(res.data);
                })
        }catch (error) {
            console.log(error);
        }finally {
            setIsLoading(false);
        }

    }useEffect(() => {
        getDarajat();
    }, []);

    const [selectedGroup, setSelectedGroups] = useState([]);

    const handleCheckboxChange1 = (event, id) => {
        const updatedSelectedEmployees = [...selectedGroup];
        const isSelected = updatedSelectedEmployees.includes(id);

        if (isSelected) {
            updatedSelectedEmployees.splice(updatedSelectedEmployees.indexOf(id), 1);
        }else {
            updatedSelectedEmployees.push(id);
        }
        setSelectedGroups(updatedSelectedEmployees);
        if(updatedSelectedEmployees.length === 0){
            tele.MainButton.hide();
        }else{
            tele.MainButton.show();
            tele.MainButton.setParams({
                text: `Selected Groups: ${updatedSelectedEmployees.length}`,});
        }
    };

    const [filteredGroups, setFilteredGroups] = useState([]); // State for filtered data
    const [searchTerm, setSearchTerm] = useState([]); // State for search term
    const [selectedOptions, setSelectedOptions] = useState([]); // State for selected options
    const handleSearch = (selectedOption) => {
        setSearchTerm(selectedOption.map((item) => item.value)); // Extract values from selected options
        const filteredData = groups.filter((group) =>
            selectedOption.some((option) =>
                (group.nameAr && group.nameAr.includes(option.value)) ||
                (group.nameEn && group.nameEn.toLowerCase().includes(option.value.toLowerCase()))
            )
        );
        if (selectedOption.length === 0) {
            setFilteredGroups(groups);
        } else {
            setFilteredGroups(filteredData);
        }
        // Update selected options based on search results (optional)
        const newSelectedOptions = selectedOption.filter((option) => groups.some((group) => group.nameAr === option.value || group.nameEn === option.value));
        setSelectedOptions(newSelectedOptions);
    };
    // Options for the select component (replace with actual data if needed)
    const options = groups.map((group) => ({
        value:  group.nameEn, // Use nameAr or nameEn based on availability
        label: group.nameAr , // Use nameAr or nameEn based on availability
    }));

    const onSendData = useCallback(() => {
        tele.MainButton.hide();
        const data = {
            groups: selectedGroup,
            id:user_id,
        }
        const response = fetch(url+'/send_darajat', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => response.json()).then(
            data => {
                // Handle successful response data here (e.g., display success message)
                alert('تم الارسال بنجاح:');
                tele.close();
            }
        )

    }, [selectedGroup])
    useEffect(() => {
        tele.onEvent('mainButtonClicked', onSendData)
        return () => {
            tele.offEvent('mainButtonClicked', onSendData)
        }
    }, [onSendData])

    const handleadd = ()=>{
        setaddDarajat(true);
    }
    const [id, setId] = useState('');

    const handleEdit = (id) => {
        setId(id);
        seteditDarajat(true);
    };
    const handleCloseAddDarajat = () => {
        setaddDarajat(false);
        getDarajat();
        setSelectedOptions([]);
    };
    const handleCloseEditDarajat = () => {
        seteditDarajat(false);
        getDarajat();
        setSelectedOptions([]);
    };
    return(
        <>
            {
                <div className="content-center flex flex-row justify-between w-auto h-auto">
                    <div className="bg-white rounded-b mx-auto w-full">
                        <div className="p-2 md:px-10 flex content-center justify-between  m-4" dir="rtl">
                            <h1 className="text-lg font-bold text-[#303BFF] text-right">
                                أهلا بك في منصة درجات
                            </h1>
                        </div>

                        <div className="p-2 md:px-8 flex justify-start  m-4" dir={"rtl"}>
                            <Select
                                isMulti
                                value={selectedOptions}
                                onChange={handleSearch}
                                options={options}
                                className="border-solid border-2 rounded-md w-1/3 max-sm:w-2/3"
                                placeholder="بحث"
                            />
                            <button className="bg-green-500 hover:bg-green-700 text-white font-bold p-2 rounded" onClick={handleadd}>اضافة مادة</button>
                        </div>
                        <div className="p-2 md:px-8 justify-center m-4 mb-6 bg-white rounded-xl">
                            {isLoading ? (
                                <div className="flex items-center justify-center"> {/* Center the content horizontally */}
                                    <img className="w-12 h-12 animate-spin mr-4" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" /> {/* Add margin for spacing */}
                                    <span className="text-xl font-bold">جاري التحميل...</span>
                                </div>
                            ):(
                                <table className="w-full text-md bg-white shadow-md rounded mb-4 table-fixed " dir="rtl">
                                    <thead className="flex flex-col items-center   w-full pl-4">
                                    <tr className="border-b text-center justify-between flex w-full  mb-4">
                                        <th className="p-3 px-4 w-1/8">-</th>
                                        {/*<th className="p-3 w-1/8">#</th>*/}
                                        <th className="p-3 w-1/4">القسم</th>
                                        <th className="p-3 w-1/4 max-sm:hidden">اسم المادة</th>
                                        <th className="p-3 w-1/4 max-sm:hidden">رمز المادة</th>
                                        <th className="p-3 w-1/4">URL</th>
                                        <th className="p-3 w-1/4">فعل</th>
                                    </tr>
                                    </thead>
                                    <tbody className="flex flex-col items-center  overflow-y-scroll h-72 max-h-96 w-full pl-3">
                                    {Array.isArray(filteredGroups)&&(filteredGroups.map((group,index)=>(
                                        <tr className="text-center hover:bg-orange-100 flex w-full  justify-between mb-4" key={index}>
                                            <td className="p-3 w-1/8 flex items-center justify-center">
                                                <input type="checkbox" checked={selectedGroup.includes(group.nameEn)}
                                                       onChange={(event) =>
                                                           handleCheckboxChange1(event,group.nameEn)
                                                       }/>
                                            </td>
                                            {/*<td className="p-3 w-1/8 flex items-center justify-center">{index+1}</td>*/}
                                            <td className="p-3 w-1/4  items-center justify-center font-medium">
                                                {group.Section}
                                                <dl className={'lg:hidden'}>
                                                    <dt className="sr-only">اسم المادة</dt>
                                                    <dd className={'text-gray-600 my-1'}>{group.nameAr}</dd>
                                                    <dt className="sr-only">الرمز</dt>
                                                    <dd className={'text-gray-600'}>{group.nameEn}</dd>
                                                </dl>
                                            </td>
                                            <td className="p-3 w-1/4 flex items-center justify-center max-sm:hidden">
                                                {group.nameAr}
                                            </td>
                                            <td className="p-3 w-1/4 flex items-center justify-center max-sm:hidden">
                                                {group.nameEn}
                                            </td>
                                            <td className="p-3 w-1/4 flex items-center justify-center text-ellipsis overflow-hidden">
                                                {group.url}
                                            </td>
                                            <td className="p-3 w-1/4 flex items-center justify-center">
                                                <button className="bg-blue-500 hover:bg-blue-700 text-white rounded p-2"
                                                        onClick={() => handleEdit(group.id)}>
                                                    تعديل
                                                </button>
                                            </td>
                                        </tr>
                                    )))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            }
            {addDarajat && <AddDarajat onClose={handleCloseAddDarajat}/>}
            {editDarajat && <EditDarajat onClose={handleCloseEditDarajat} id={id}/>}
        </>
    );

}

export default DarajatAdmin